import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type NavigationBarResponse = OAISchema['PlacementNavigationBarResponse'][];

export interface PlacementDataSource {
  getNavigationBars(businessId: number): Promise<NavigationBarResponse>;
}

export class PlacementDataSourceImpl implements PlacementDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getNavigationBars(businessId: number) {
    return this.client.request<NavigationBarResponse>({
      url: '/api/market-place/v1/placements/navigation-bars-new',
      method: 'get',
      params: { businessId },
    });
  }
}

export const placementDataSource = new PlacementDataSourceImpl();
